import React from "react";
import PropTypes from "prop-types";
import AssociatedTenantsTable from "./AssociatedTenantsTable";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";
import ContentCard from "../../../common/components/ContentCard/ContentCard";

export default class BillingOrganizationsInfo extends React.Component {

    static propTypes = {
        organizationDetail: PropTypes.object,
        associatedAddresses: PropTypes.array,
        associatedBilling: PropTypes.object,
        associatedTenants: PropTypes.array,
    }

    render() {

        const {associatedAddresses, associatedBilling , associatedTenants} = this.props;

        return(
            <div className="detail-container">
                <div>
                    <ContentCard
                        headerContent={"Overview"}
                    >
                        <div className={"parent"}>
                            {associatedAddresses.map((address, idx) => {
                                return (
                                    <div key={idx}>
                                        <label>{toUpperCaseSentence(address.type + " Address")}:</label>
                                        {address.thoroughfare
                                            ? (<p>{"Thoroughfare: "}{address.thoroughfare}</p>)
                                            : null }
                                        {address.premise
                                            ? (<p>{"Premise: "}{address.premise}</p>)
                                            : null }
                                        {address.locality
                                            ? (<p>{"Locality: "}{address.locality}</p>)
                                            : null }
                                        {address.postal_code
                                            ? (<p>{"Postal Code: "}{address.postal_code}</p>)
                                            : null }
                                        {address.region
                                            ? (<p>{"Region: "}{address.region}</p>)
                                            : null }
                                        {address.country
                                            ? (<p>{"Country: "}{address.country}</p>)
                                            : null }
                                    </div>
                                )
                            })}
                            <div>
                                <label>{"Billing Details:"}</label>
                                <p>{"Billing A Number: "}{associatedBilling.billing_a_number}</p>
                                <p>{"Location A Number: "}{associatedBilling.location_a_number}</p>
                                <p>{"Min. Monthly Commitment: "}{associatedBilling.monthly_minimum_commitment}</p>
                                <p>{"Monthly Platform Fee: "}{associatedBilling.monthly_platform_fee}</p>
                            </div>
                        </div>

                    </ContentCard>
                </div>
                {/*Only render the Tenants and Configs table if we get something back*/}
                {associatedTenants.length >= 1
                    ? (<AssociatedTenantsTable associatedTenants={associatedTenants}/>)
                    : null }
            </div>
        );
    }
}
